import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField } from "@mui/material";

const SaveDialog = ({ open, onClose, templateName, onTemplateNameChange, onSave }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Are you sure you want to save the template?</DialogTitle>
      <DialogContent>
        <TextField
          placeholder="Template Name"
          value={templateName}
          onChange={(e) => onTemplateNameChange(e.target.value)}
          fullWidth
          required
          margin="dense"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onSave} variant="contained" color="primary">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveDialog;
